import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=0304f9ca&scoped=true"
import script from "./EmptyView.vue?vue&type=script&lang=js"
export * from "./EmptyView.vue?vue&type=script&lang=js"
import style0 from "./EmptyView.vue?vue&type=style&index=0&id=0304f9ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0304f9ca",
  null
  
)

export default component.exports